import { GenerateReportResponse, CreateLinkRequest } from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function downloadAllExpensesSummary(): Promise<Blob> {
  return httpClient.get('files-reports/all-expenses-summary').blob();
}

export async function downloadAllCostCentersSummary(): Promise<Blob> {
  return httpClient.get('files-reports/all-cost-centers-summary').blob();
}

export async function generateReport(
  reportType: 'all-cost-centers-summary' | 'all-expenses-summary',
  dateFrom: string,
  dateTo: string,
): Promise<CreateLinkRequest> {
  return httpClient.get(`files-reports/${reportType}?dateFrom=${dateFrom}&dateTo=${dateTo}`).json();
}

export async function checkReportGenerationStatus(
  reportType: 'all-cost-centers-summary' | 'all-expenses-summary',
  dateFrom: string,
  dateTo: string,
): Promise<GenerateReportResponse> {
  return httpClient
    .get(`files-reports/${reportType}/status?dateFrom=${dateFrom}&dateTo=${dateTo}`)
    .json();
}
